/*
NAME: MonitoringItem
DESC: Componente resposavel por exibir um equipamento na lista de equipamentos especifico por meio do ID
props:
- item: Array de objetos, de um determinado equipamento
- - - - Default
- style: Object, style object to overwrite this component style

NOTES:
#TODO - Não está sendo opssivel monitorar os trabalhos do inacio, pois provavlemente estão finalizados no servidor 
*/

import { Autocomplete, Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, LinearProgress, Stack, TextField, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ReorderIcon from '@mui/icons-material/Reorder';
import BasicCard from "../basic/BasicCard";
import RowContainer from "../basic/RowContainer";
import RowContainerItem from "../basic/RowContainerItem";
import values from '../../values/values'
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Alert from '@mui/material/Alert';
import DateFormat from "../../usecases/DateFormat";
import strings from "../../values/strings/strings";
import MonitorChartLimits from "../specific/MonitorChartLimits";
import DateRangeIcon from '@mui/icons-material/DateRange';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SpeedIcon from '@mui/icons-material/Speed';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PersonIcon from '@mui/icons-material/Person';
import MapIcon from '@mui/icons-material/Map';
import TimelineIcon from '@mui/icons-material/Timeline';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import RoomIcon from '@mui/icons-material/Room';
import TextureIcon from '@mui/icons-material/Texture';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DoneIcon from '@mui/icons-material/Done';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ExpandIcon from '@mui/icons-material/Expand';
import ReportIcon from '@mui/icons-material/Report';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import WorkGetErrorVelocidade from "../../usecases/WorkGetErrorVelocidade";
import WorkGetErrorTemperature from "../../usecases/WorkGetErrorTemperature";
import WorkGetErrorSeedsMeter from "../../usecases/WorkGetErrorSeedsMeter";
import WorkGetErrotCurrentPressure from "../../usecases/WorkGetErrotCurrentPressure";
import WorksPulvSectionDisplay from "../specific/WorksPulvSectionDisplay";
import WorksGetData from "../../usecases/WorksGetData";
import WorksGetMonitoring from "../../usecases/WorksGetMonitoring";
import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff';
import Agriculture from '@mui/icons-material/Agriculture';
import ErrorCard from "../basic/ErrorCard";
import AutorenewIcon from '@mui/icons-material/Autorenew'
import MapPanel from "../basic/MapPanel";
import { countGroupedHistoryLines, filterLinesParticipatingInCount, isAlternatingLineConfiguration, resolveDisplayLineCount, resolveDisplayLineSpacingCm, resolveImplementWidthMeters } from "../../usecases/mapPathUtils";
import APIManager from "../../connection/APIManager";
import AuthBuildHeaderUserObject from "../../usecases/AuthBuildHeaderUserObject";
import { getWorkColorByIndex } from "../../usecases/graphMultiWorkUtils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const safeToFixed = (value, digits, fallback = ' - - ') =>
  (value != null && !isNaN(Number(value))) ? Number(value).toFixed(digits) : fallback;

const TIME_LIMIT = 10

const monitorInfoCardStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    padding: 5,
    margin: 5,
};

const monitorFieldsRowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    boxSizing: 'border-box',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 8,
};

const monitorFieldStyle = {
    margin: 5,
    flex: '0 0 200px',
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    boxSizing: 'border-box',
};

const monitorSectionTitleStyle = {
    width: '100%',
    textAlign: 'left',
    marginTop: values.margin[2],
    marginBottom: values.margin[1],
};



function MonitoringItem({ item, style, setItemSelecionado }) {
    const navigation = useHistory();
    const [updater, setUpdater] = useState(null)
    const [loading, setLoading] = useState(false)
    const [trabalho, settrabalho] = useState(null)  //#TODO - Chamar esta variavel no lugar de item
    const [horasTrabalhadas, sethorasTrabalhadas] = useState(null)
    const [distanciaPercorrida, setdistanciaPercorrida] = useState(null)
    const [operador, setoperador] = useState(null)
    const [talhao, settalhao] = useState(null)
    const [velocidadeMedia, setvelocidadeMedia] = useState("- -")
    const [areaPlantada, setareaPlantada] = useState(null)
    const [sementesMetro, setsementesMetro] = useState(null)
    const [sementesHectare, setsementesHectare] = useState(null)
    const [populacaoTotal, setpopulacaoTotal] = useState(null)
    const [populacaoMedia, setpopulacaoMedia] = useState(null)
    const [linhasPlantadeiraMedia, setlinhasPlantadeira] = useState(null)
    const [areaPulverizada, setareaPulverizada] = useState(null)
    const [pressaoAtual, setpressaoAtual] = useState(null)
    const [vazaoAlvo, setvazaoAlvo] = useState(null)
    const [vazaoAtual, setvazaoAtual] = useState(null)
    const [vazaoAtualMin, setvazaoAtualMin] = useState(null)
    const [litrosConsumidos, setlitrosConsumidos] = useState(null)
    const [temperaturaAtual, settemperaturaAtual] = useState(null)
    const [populacaoMedialinha, setpopulacaoMedialinha] = useState(null)
    const [configVelMax, setconfigVelMax] = useState(null)
    const [configTemperaturaMax, setconfigTemperaturaMax] = useState(0)
    const [pressaoMinPsi, setpressaoMinPsi] = useState(0)
    const [pressaoMaxPsi, setpressaoMaxPsi] = useState(0)
    const [taxaSementesMetroMax, settaxaSementesMetroMax] = useState(0)
    const [taxaSementesMetroMin, settaxaSementesMetroMin] = useState(0)
    const [taxaSementesMetro, settaxaSementesMetro] = useState(0)
    const [antemaAlturaM, setantemaAlturaM] = useState(0)
    const [especamentoLinhas, setespecamentoLinhas] = useState(0)
    const [velocidadeMaxPermitida, setvelocidadeMaxPermitida] = useState(0)
    const [erroTemperaturaAtual, seterroTemperaturaAtual] = useState(false)
    const [validaVelocidade, setvalidaVelocidade] = useState(false)
    const [erroSementeMetro, seterroSementeMetro] = useState(false)
    const [erroPressaoAtual, seterroPressaoAtual] = useState(false)
    const [diftime, setdiftime] = useState(null)
    const [marker, setMarker] = useState([])
    const [linhas, setLinhas] = useState([])
    const [centerMap, setcenterMap] = useState(null)
    const [histCoords, setHistCoords] = useState([])
    const [mainVisible, setMainVisible] = useState(true)
    const [availableTrabalhos, setAvailableTrabalhos] = useState([])
    const [extraTrabalhos, setExtraTrabalhos] = useState([])
    const [extraSlots, setExtraSlots] = useState([])
    const nextSlotIdRef = useRef(1)
    const extraIdsRef = useRef([])

    const formatTrabalhoLabel = useCallback((t) => {
        if (!t) return '';
        const parts = [`#${t.id}`];
        if (t.data_inicio) parts.push(DateFormat(new Date(t.data_inicio)));
        if (t.cultura && t.cultura.nome) parts.push(t.cultura.nome);
        if (t.talhao) parts.push(t.talhao);
        if (t.operador) parts.push(t.operador);
        const tipos = [];
        if (t.plantio?.id) tipos.push('Plantio');
        if (t.pulv?.id) tipos.push('Pulverização');
        parts.push(tipos.length > 0 ? tipos.join(' e ') : 'GPS');
        return parts.join(' | ');
    }, []);

    const fetchHistCoords = useCallback(async (trabalhoId) => {
        const obj = await AuthBuildHeaderUserObject().catch(() => null);
        if (!obj) {
            throw new Error('Sessão inválida');
        }
        const response = await APIManager.send('/trabalho/histcoords', 'GET', {
            ...obj,
            trabalho_id: trabalhoId,
        });
        const json = await response.json();
        return Array.isArray(json) ? json : [];
    }, []);

    const loadExtraTrabalhoData = useCallback(async (trabalhoId) => {
        setExtraTrabalhos(prev => {
            if (prev.some(e => e.id === trabalhoId)) {
                return prev.map(e => e.id === trabalhoId ? { ...e, loading: true, progress: 10 } : e);
            }
            return [...prev, {
                id: trabalhoId,
                trabalho: availableTrabalhos.find(t => t.id === trabalhoId) || null,
                histCoords: [],
                loading: true,
                progress: 10,
            }];
        });

        try {
            const coords = await fetchHistCoords(trabalhoId);
            setExtraTrabalhos(prev => prev.map(e => e.id === trabalhoId ? {
                ...e,
                histCoords: coords,
                loading: false,
                progress: 100,
            } : e));
        } catch (err) {
            console.error(`Erro ao carregar coordenadas do trabalho extra ${trabalhoId}:`, err);
            setExtraTrabalhos(prev => prev.map(e => e.id === trabalhoId ? {
                ...e,
                loading: false,
                progress: 100,
            } : e));
        }
    }, [availableTrabalhos, fetchHistCoords]);

    const refreshExtraCoords = useCallback(async () => {
        const ids = extraIdsRef.current;
        if (!ids.length) return;
        await Promise.all(ids.map(async (trabalhoId) => {
            try {
                const coords = await fetchHistCoords(trabalhoId);
                setExtraTrabalhos(prev => prev.map(e => e.id === trabalhoId ? {
                    ...e,
                    histCoords: coords,
                    loading: false,
                    progress: 100,
                } : e));
            } catch (err) {
                console.error(`Erro ao atualizar coordenadas do trabalho extra ${trabalhoId}:`, err);
            }
        }));
    }, [fetchHistCoords]);

    const removeExtraTrabalho = useCallback((slotId) => {
        setExtraSlots(prev => {
            const slot = prev.find(s => s.slotId === slotId);
            if (slot && slot.trabalhoId) {
                setExtraTrabalhos(prevExtra => prevExtra.filter(e => e.id !== slot.trabalhoId));
            }
            return prev.filter(s => s.slotId !== slotId);
        });
    }, []);

    const addExtraSlot = useCallback(() => {
        const slotId = nextSlotIdRef.current++;
        setExtraSlots(prev => [...prev, { slotId, trabalhoId: null }]);
    }, []);

    const selectExtraTrabalho = useCallback((slotId, trabalhoId) => {
        setExtraSlots(prev => {
            const slot = prev.find(s => s.slotId === slotId);
            if (slot && slot.trabalhoId && slot.trabalhoId !== trabalhoId) {
                setExtraTrabalhos(prevExtra => prevExtra.filter(e => e.id !== slot.trabalhoId));
            }
            return prev.map(s => s.slotId === slotId ? { ...s, trabalhoId } : s);
        });
        if (trabalhoId) {
            loadExtraTrabalhoData(trabalhoId);
        }
    }, [loadExtraTrabalhoData]);

    const selectedExtraIds = useMemo(() => {
        return new Set(extraSlots.map(s => s.trabalhoId).filter(Boolean));
    }, [extraSlots]);

    const workColorById = useMemo(() => {
        const ids = [];
        if (item?.id) ids.push(item.id);
        extraSlots.forEach((slot) => {
            if (slot.trabalhoId && !ids.includes(slot.trabalhoId)) {
                ids.push(slot.trabalhoId);
            }
        });
        const map = {};
        ids.forEach((id, index) => {
            map[id] = id === item?.id ? '#19c119' : getWorkColorByIndex(index - 1);
        });
        return map;
    }, [item, extraSlots]);

    const buildPolilinhasFromCoordsList = useCallback((works, fallbackCenter) => {
        if (!works.length) return { linhas: [], markers: [], center: fallbackCenter, legend: [] };

        const segments = [];
        const legend = [];
        let firstCoord = null;
        let lastCoord = null;

        for (const work of works) {
            const coords = (work.coords || [])
                .filter(c => c.lat != null && c.lng != null)
                .map(c => ({
                    lat: parseFloat(c.lat),
                    lng: parseFloat(c.lng),
                    alt: c.alt != null ? parseFloat(c.alt) : undefined,
                }));

            if (!coords.length) continue;

            if (!firstCoord) firstCoord = coords[0];
            lastCoord = coords[coords.length - 1];

            let seg = [{ lat: coords[0].lat, lng: coords[0].lng }];
            for (let i = 1; i < coords.length; i++) {
                const prev = coords[i - 1];
                const curr = coords[i];
                const dist = values.distanceBetweenpointsM(prev.lat, prev.lng, prev.alt, curr.lat, curr.lng, curr.alt);
                if (dist > 20 && seg.length > 0) {
                    segments.push({
                        path: seg,
                        color: work.color,
                        trabalhoId: work.id,
                        workLabel: work.label,
                    });
                    seg = [];
                }
                seg.push({ lat: curr.lat, lng: curr.lng });
            }
            if (seg.length > 0) {
                segments.push({
                    path: seg,
                    color: work.color,
                    trabalhoId: work.id,
                    workLabel: work.label,
                });
            }
            legend.push({ id: work.id, label: work.label, color: work.color });
        }

        if (!firstCoord) return { linhas: [], markers: [], center: fallbackCenter, legend: [] };

        return {
            linhas: segments,
            markers: [
                { latitude: firstCoord.lat, longitude: firstCoord.lng, coordinateType: 'first' },
                { latitude: lastCoord.lat, longitude: lastCoord.lng, coordinateType: 'last' },
            ],
            center: { lat: lastCoord.lat, lng: lastCoord.lng },
            legend,
        };
    }, []);

    const mergedLinhas = useMemo(() => {
        const works = [];
        if (mainVisible && histCoords?.length) {
            works.push({
                id: item?.id,
                label: trabalho ? `${formatTrabalhoLabel(trabalho)} (aberto)` : `#${item?.id} (aberto)`,
                color: workColorById[item?.id],
                coords: histCoords,
            });
        }
        for (const extra of extraTrabalhos) {
            if (!extra.histCoords?.length) continue;
            const extraTrabalho = extra.trabalho || availableTrabalhos.find(t => t.id === extra.id);
            works.push({
                id: extra.id,
                label: extraTrabalho ? formatTrabalhoLabel(extraTrabalho) : `#${extra.id}`,
                color: workColorById[extra.id],
                coords: extra.histCoords,
            });
        }
        return buildPolilinhasFromCoordsList(works, centerMap);
    }, [mainVisible, histCoords, extraTrabalhos, availableTrabalhos, trabalho, item, workColorById, centerMap, buildPolilinhasFromCoordsList, formatTrabalhoLabel]);

    useEffect(() => {
        extraIdsRef.current = extraSlots.map(s => s.trabalhoId).filter(Boolean);
    }, [extraSlots]);

    const getWorkData = useCallback(async () => {
        try {
            setLoading(true)
            const trabalho = await WorksGetData(item.id, true)
            settrabalho(trabalho[0])
        } catch (err) {
            console.error('Erro ao buscar trabalho:', err)
            settrabalho(null)
        } finally {
            setLoading(false)
        }
    }, [item])

    const fetchAvailableTrabalhos = useCallback(async () => {
        try {
            const list = await WorksGetMonitoring(null, null, true);
            if (Array.isArray(list)) {
                setAvailableTrabalhos(list.filter(t => t.id !== item?.id));
            }
        } catch (err) {
            console.error('Erro ao buscar trabalhos em modo resumo:', err);
            setAvailableTrabalhos([]);
        }
    }, [item]);

    useEffect(() => {
        if (item) fetchAvailableTrabalhos();
    }, [item, fetchAvailableTrabalhos]);

    useEffect(() => {
        let newInterval = setInterval(() => {
            getWorkData().catch((err) => {
                console.error('Erro ao atualizar trabalho no intervalo:', err);
            });
            refreshExtraCoords().catch((err) => {
                console.error('Erro ao atualizar coordenadas extras no intervalo:', err);
            });
            fetchAvailableTrabalhos().catch((err) => {
                console.error('Erro ao atualizar lista de trabalhos no intervalo:', err);
            });
        }, 5000)
        setUpdater(newInterval)

        const onClose = () => {
            clearInterval(newInterval)
        }
        return onClose
    }, [getWorkData, refreshExtraCoords, fetchAvailableTrabalhos])

    useEffect(() => {
        if (item) {
            getWorkData()
        }else {
            settrabalho(null)
        }
    }, [item])

    useEffect(() => {
        if (trabalho) {
            bindData(trabalho)
            loadMapData(trabalho)
        }

        if (!trabalho && updater) clearInterval(updater)

    }, [trabalho]);

    const loadMapData = (trabalho) => {
        if (!trabalho || !trabalho.id) {
            console.warn('Trabalho inválido para carregar dados do mapa');
            return;
        }

        const fetchData = async () => {
            try {
                const json = await fetchHistCoords(trabalho.id);

                if (!json.length) {
                    console.warn('Resposta da API não contém dados válidos de coordenadas');
                    setMarker([]);
                    setLinhas([]);
                    setHistCoords([]);
                    return;
                }

                setHistCoords(json);
                polilinhas(json);
            } catch (error) {
                console.error('Erro ao carregar dados da API:', error);
                setMarker([]);
                setLinhas([]);
                setHistCoords([]);
            }
        };

        fetchData();
    };
    
    const polilinhas = (trabalho) => {
        if (!trabalho || !Array.isArray(trabalho) || trabalho.length === 0) {
            console.warn('Nenhuma coordenada disponível para exibir no mapa');
            setMarker([]);
            setLinhas([]);
            return;
        }
    
        const coords = trabalho
            .filter(item => item.lat != null && item.lng != null) // Filtra coordenadas válidas
            .map(item => ({
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lng),
                alt: item.alt != null ? parseFloat(item.alt) : undefined,
            }));
        
        if (coords.length === 0) {
            console.warn('Nenhuma coordenada válida encontrada');
            setMarker([]);
            setLinhas([]);
            return;
        }
        
        const linhasSegmentos = [];
        let segmentoAtual = [{ lat: coords[0].lat, lng: coords[0].lng }];
        for (let i = 1; i < coords.length; i++) {
            const prev = coords[i - 1];
            const curr = coords[i];
            const distance = values.distanceBetweenpointsM(
                prev.lat, prev.lng, prev.alt,
                curr.lat, curr.lng, curr.alt
            );
            if (distance > 20 && segmentoAtual.length > 0) {
                linhasSegmentos.push({ path: segmentoAtual });
                segmentoAtual = [];
            }
            segmentoAtual.push({ lat: curr.lat, lng: curr.lng });
        }
        if (segmentoAtual.length > 0) {
            linhasSegmentos.push({ path: segmentoAtual });
        }
        
        const lastPonto = {
            latitude: coords[coords.length - 1].lat,
            longitude: coords[coords.length - 1].lng,
            coordinateType: 'last',
        };
        const firstPonto = {
            latitude: coords[0].lat,
            longitude: coords[0].lng,
            coordinateType: 'first',
        };
        
        const markers = [lastPonto, firstPonto];
        const centerMap = { lat: coords[coords.length - 1].lat, lng: coords[coords.length - 1].lng };
        
        setMarker(markers);
        setLinhas(linhasSegmentos);
        setcenterMap(centerMap);
    }

    const zoomMap = 15;
    
    const bindData = (trabalho) => { //#TODO - Mudar item para trabalho
        //Dados Gerais
        let op = ' - - '
        if (trabalho.operador) { op = trabalho.operador }
        setoperador(op)

        let talh = ' - - '
        if (trabalho.talhao) { talh = trabalho.talhao }
        settalhao(talh)

        let vel = ' - - '
        if (trabalho.coordenada && trabalho.coordenada.velocidade_antena_kmh != null) {
            vel = safeToFixed(trabalho.coordenada.velocidade_antena_kmh, 1, ' - - ') + ' km/h'
        }
        setvelocidadeMedia(vel)

        setvalidaVelocidade(WorkGetErrorVelocidade(trabalho))

        let dist = ' - - '
        if (trabalho.plantio && trabalho.plantio.plantio_ponto && trabalho.plantio.plantio_ponto.metros_percorridos != null) {
            dist = safeToFixed(trabalho.plantio.plantio_ponto.metros_percorridos, 2, '0.00') + ` m`
        } else if (trabalho.pulv && trabalho.pulv.pulv_ponto && trabalho.pulv.pulv_ponto.metros_percorridos != null) {
            dist = safeToFixed(trabalho.pulv.pulv_ponto.metros_percorridos, 2, '0.00') + ` m`
        } else if (trabalho.gps && trabalho.gps.gps_ponto && trabalho.gps.gps_ponto.metros_percorridos != null) {
            dist = safeToFixed(trabalho.gps.gps_ponto.metros_percorridos, 2, '0.00') + ` m`
        } else {
            dist = '0.00 m '
        }
        setdistanciaPercorrida(dist)

        //Dados de Plantio

        //VERIFICAR O POR QUE ESTA DANDO ERRO NO CÓDIGO, NÃO ESTA BUSCANDO OS DADOS DE PLANTIO
        if(trabalho.plantio && trabalho.plantio.plantio_ponto) {
        let areaPlant = ' 0,00 ha'
        if (trabalho.plantio) { areaPlant = safeToFixed(trabalho.plantio.plantio_ponto.areaplantada_ha, 2, '0,00') + ` ha` }
        setareaPlantada(areaPlant)

        let sementesM = ' - - '
        if (trabalho.plantio) { sementesM = safeToFixed(trabalho.plantio.plantio_ponto.sementes_metro_total, 2) + ` s/m` }
        setsementesMetro(sementesM)

        seterroSementeMetro(WorkGetErrorSeedsMeter(trabalho))

        let sementesH = ' - - '
        if (trabalho.plantio) { sementesH = safeToFixed(trabalho.plantio.plantio_ponto.sementes_hectare_total, 2) + ` s/ha` }
        setsementesHectare(sementesH)

        let populacaoT = ' - - '
        if (trabalho.plantio) { populacaoT = safeToFixed(trabalho.plantio.plantio_ponto.populacao, 2) + ` ppl` }
        setpopulacaoTotal(populacaoT)

        let populacaoM = ' - - '
        if (trabalho.plantio) { populacaoM = trabalho.plantio.plantio_ponto.populacao_media_linha + ` ppl/ha` }  //condicional de populacao media
        setpopulacaoMedia(populacaoM)

        // Mesma inferência do mapa/detalhes: se as linhas do ponto atual
        // indicarem plantio alternado, usa a qtd efetiva (não a config total).
        let linhasPlant = ' - - '
        const configuredLineCount =
            trabalho.plantio?.config_qtd_linhas ?? trabalho.pulv?.config_qtd_linhas
        const pointLinhas = Array.isArray(trabalho.plantio?.plantio_ponto?.linhas)
            ? trabalho.plantio.plantio_ponto.linhas
            : Array.isArray(trabalho.pulv?.pulv_ponto?.sessoes)
                ? trabalho.pulv.pulv_ponto.sessoes.map((sessao, index) => ({
                    numero: sessao.numero != null ? sessao.numero : index + 1,
                }))
                : []
        const groupedLineCountRaw = countGroupedHistoryLines(pointLinhas)
        const activeLinhas = filterLinesParticipatingInCount(pointLinhas)
        const groupedLineCount = countGroupedHistoryLines(activeLinhas)
        const numeros = pointLinhas
            .map((item) => item?.numero)
            .filter((numero) => numero != null)
        const numerosAtivos = activeLinhas
            .map((item) => item?.numero)
            .filter((numero) => numero != null)
        const populacoes = pointLinhas.map((item) => ({
            numero: item?.numero,
            populacao: item?.populacao,
        }))
        const isAlternating = isAlternatingLineConfiguration(groupedLineCount, Number(configuredLineCount))
        const displayLineCount = resolveDisplayLineCount(configuredLineCount, pointLinhas)
        console.log('[MonitoringItem] inferência linhas', {
            trabalhoId: trabalho?.id,
            configuredLineCount,
            pointLinhasLength: pointLinhas.length,
            activeLinhasLength: activeLinhas.length,
            numeros,
            numerosAtivos,
            populacoes,
            groupedLineCountRaw,
            groupedLineCount,
            isAlternating,
            displayLineCount,
            plantioTemLinhas: Array.isArray(trabalho.plantio?.plantio_ponto?.linhas),
            pulvTemSessoes: Array.isArray(trabalho.pulv?.pulv_ponto?.sessoes),
        })
        if (displayLineCount != null) {
            linhasPlant = displayLineCount
        }
        setlinhasPlantadeira(linhasPlant)
        }

        ////pulverizacao
        if(trabalho.pulv && trabalho.pulv.pulv_ponto) {
        let areaPulv = ' - - '
        if (trabalho.pulv) { areaPulv = safeToFixed(trabalho.pulv.pulv_ponto.area_pulverizada, 2) + ` ha` }
        setareaPulverizada(areaPulv)

        let pressao = ' - - '
        if (trabalho.pulv) { pressao = safeToFixed(trabalho.pulv.pulv_ponto.pressao_atual_psi, 2) + ` psi` }
        setpressaoAtual(pressao)

        seterroPressaoAtual(WorkGetErrotCurrentPressure(trabalho))

        let temperatura = ' - - '
        if (trabalho.pulv) { temperatura = (trabalho.pulv.pulv_ponto.temperatura != null ? trabalho.pulv.pulv_ponto.temperatura : ' - - ') + ` ºC` }
        settemperaturaAtual(temperatura)

        seterroTemperaturaAtual(WorkGetErrorTemperature(trabalho))

        let litro = ' - - '
        if (trabalho.pulv) { litro = safeToFixed(trabalho.pulv.pulv_ponto.litros_consumidos, 2) + ` L` }
        setlitrosConsumidos(litro)
        }

        let maxTemp = ' - - '
        if (trabalho.pulv) { maxTemp = trabalho.pulv.config_temp_max }  //condicional de temperatura maxima
        setconfigTemperaturaMax(maxTemp)

        let PressaoMinPsi = ' - - '
        if (trabalho.pulv) { PressaoMinPsi = trabalho.pulv.config_pressao_min_psi }  //condicional de pressao minima
        setpressaoMinPsi(PressaoMinPsi)

        let PressaoMaxPsi = ' - - '
        if (trabalho.pulv) { PressaoMaxPsi = trabalho.pulv.config_pressao_max_psi }  //condicional de pressao maxima
        setpressaoMaxPsi(PressaoMaxPsi)

        let TaxaSementeMetroMax = ' - - '
        if (trabalho.plantio) { TaxaSementeMetroMax = trabalho.plantio.config_sementesmetro_max }  //condicional de taxa de sementes por metro
        settaxaSementesMetroMax(TaxaSementeMetroMax)

        let TaxaSementeMetroMin = ' - - '
        if (trabalho.plantio) { TaxaSementeMetroMin = trabalho.plantio.config_sementesmetro_min }  //condicional de taxa de sementes por metro
        settaxaSementesMetroMin(TaxaSementeMetroMin)

        let TaxaSementeMetro = ' - - '
        if (trabalho.plantio) { TaxaSementeMetro = trabalho.plantio.config_sementesmetro }  //condicional de taxa de sementes por metro
        settaxaSementesMetro(TaxaSementeMetro)

        let AntenaAlturaM = ' - - '
        if (trabalho.antena_altura_m) { AntenaAlturaM = trabalho.antena_altura_m }  //condicional de taxa de sementes por metro
        setantemaAlturaM(AntenaAlturaM)

        let EspacamentoLinhas = ' - - '
        const configEspacamentoCm =
            trabalho.plantio?.config_espacamento_cm ?? trabalho.pulv?.config_espacamento_cm
        if (configEspacamentoCm != null) {
            // Mesma inferência das linhas: plantio alternado → dobra o espaçamento efetivo.
            const configuredLineCountForSpacing =
                trabalho.plantio?.config_qtd_linhas ?? trabalho.pulv?.config_qtd_linhas
            const pointLinhasForSpacing = Array.isArray(trabalho.plantio?.plantio_ponto?.linhas)
                ? trabalho.plantio.plantio_ponto.linhas
                : Array.isArray(trabalho.pulv?.pulv_ponto?.sessoes)
                    ? trabalho.pulv.pulv_ponto.sessoes.map((sessao, index) => ({
                        numero: sessao.numero != null ? sessao.numero : index + 1,
                    }))
                    : []
            const displaySpacing = resolveDisplayLineSpacingCm(
                configEspacamentoCm,
                configuredLineCountForSpacing,
                pointLinhasForSpacing
            )
            EspacamentoLinhas = displaySpacing != null ? displaySpacing : configEspacamentoCm
        }
        setespecamentoLinhas(EspacamentoLinhas)

        let VelocidadeMaxPermitida = ' - - '
        if (trabalho.plantio) { VelocidadeMaxPermitida = trabalho.plantio.config_vel_kmh_max }  //condicional de taxa de sementes por metro
        setvelocidadeMaxPermitida(VelocidadeMaxPermitida)
        

        // Diferença de tempo entre a data do trabalho ea data atual para verificar o status do trabalho    
        let now = new Date()
        let date = new Date(trabalho.data_update_server)
        let dif = now.getTime() - date.getTime()
        dif = dif / 1000 / 60
        setdiftime(dif)

        //Horas Trabalhadas (plantio, pulv ou gps.gps_ponto para trabalho em tempo real do app GPS)
        let milliseconds = null
        if (trabalho.plantio && trabalho.plantio.plantio_ponto && trabalho.plantio.plantio_ponto.millsec_trabalhados != null) {
            milliseconds = trabalho.plantio.plantio_ponto.millsec_trabalhados
        } else if (trabalho.pulv && trabalho.pulv.pulv_ponto && trabalho.pulv.pulv_ponto.millsec_trabalhados != null) {
            milliseconds = trabalho.pulv.pulv_ponto.millsec_trabalhados
        } else if (trabalho.gps && trabalho.gps.gps_ponto) {
            const ms = trabalho.gps.gps_ponto.millsec_trabalhados
            if (ms != null && Number(ms) > 0) milliseconds = ms
            else if (trabalho.data_inicio) {
                const fim = trabalho.data_fim || trabalho.gps.gps_ponto.data_cad_device
                if (fim) {
                    const ini = new Date(trabalho.data_inicio).getTime()
                    const f = new Date(fim).getTime()
                    if (!isNaN(ini) && !isNaN(f)) milliseconds = Math.max(0, f - ini)
                }
            }
        }
        if (milliseconds != null) {
            let horas = Number(milliseconds) / 1000 / 60 / 60
            let minutos = horas - Math.floor(horas)
            minutos = minutos * 60
            sethorasTrabalhadas(Math.floor(horas) + 'h' + Math.floor(minutos) + 'min')
        }


        //Vazão
        if (trabalho.pulv && trabalho.pulv.pulv_ponto) {
            setvazaoAlvo(trabalho.pulv.pulv_ponto.vazao_geral_lha)
            setvazaoAtual(trabalho.pulv.pulv_ponto.vazao_atual_lha)
            setvazaoAtualMin(trabalho.pulv.pulv_ponto.vazao_atual_lmin)
        } else {
            setvazaoAlvo('----')
            setvazaoAtual('----')
            setvazaoAtualMin('----')
        }


    }

    const renderTrabalhoStatus = () => {

        if (!trabalho.trabalho_status) return <Alert variant="filled" icon={<AutorenewIcon />} severity="info" style={{ marginBottom: values.margin[1] }}>OBTENDO DADOS ...</Alert>

        if (diftime >= TIME_LIMIT) {
            return (
                <Alert variant="filled" icon={<SignalWifiOffIcon />} style={{ backgroundColor: '#757575', marginBottom: values.margin[1] }} > TRABALHO DESCONECTADO</Alert>
            )
        }
        if (trabalho.trabalho_status === 'FINALIZADO') {
            return (
                <Alert variant="filled" severity="success" style={{ marginBottom: values.margin[1] }}>TRABALHO FINALIZADO</Alert>
            )
        }
        if (trabalho.trabalho_status === 'PARADO') {
            return (
                <Alert variant="filled" severity='warning' style={{ marginBottom: values.margin[1] }}> TRABALHO PARADO</Alert>
            )
        }

        if (trabalho.trabalho_status === 'INICIADO') {
            return (
                <Alert variant="filled" icon={<Agriculture />} style={{ marginBottom: values.margin[1] }}> TRABALHO INICIADO </Alert>
            )
        }

    }

    const onGoBack = useCallback(() => {
        setItemSelecionado(null);
        navigation.goBack();
    }, [setItemSelecionado, navigation]);


    return (
        <>
            <Button onClick={onGoBack}>Voltar</Button>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
                {trabalho && //#TODO - Solução provissória para não dar erro de null
                    <RowContainer style={{ width: '100%', maxWidth: '100%' }}>
                      <RowContainerItem>

                        <BasicCard style={{ marginBottom: values.margin[1], flexDirection: 'column' }}>
                                <Typography variant="subtitle1" color="primary" sx={{ mb: 1, fontWeight: 'bold', width: '100%' }}>
                                    <ReorderIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                                    Trabalhos selecionados
                                </Typography>

                                <Box sx={{ width: '100%', mb: 1, p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, backgroundColor: 'action.hover' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 0 }}>
                                            <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: workColorById[item?.id] || '#19c119', flexShrink: 0 }} />
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', flex: 1 }}>
                                                {trabalho ? formatTrabalhoLabel(trabalho) : `#${item?.id || ''}`}
                                                <Typography component="span" variant="caption" color="primary" sx={{ ml: 1 }}>(aberto)</Typography>
                                            </Typography>
                                        </Box>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={mainVisible}
                                                    onChange={(e) => setMainVisible(e.target.checked)}
                                                    size="small"
                                                />
                                            }
                                            label={<Typography variant="caption">Visualizar</Typography>}
                                            sx={{ ml: 1, mr: 0, flexShrink: 0 }}
                                        />
                                    </Box>
                                </Box>

                                {extraSlots.map((slot) => {
                                    const extraData = extraTrabalhos.find(e => e.id === slot.trabalhoId);
                                    const selectableTrabalhos = availableTrabalhos.filter(t =>
                                        t.id !== item?.id && (!selectedExtraIds.has(t.id) || t.id === slot.trabalhoId)
                                    );
                                    return (
                                        <Box key={slot.slotId} sx={{ width: '100%', mb: 1, p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                                                {slot.trabalhoId && (
                                                    <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: workColorById[slot.trabalhoId] || '#19c119', flexShrink: 0 }} />
                                                )}
                                                <Autocomplete
                                                    sx={{ flex: 1 }}
                                                    size="small"
                                                    options={selectableTrabalhos}
                                                    getOptionLabel={(option) => formatTrabalhoLabel(option)}
                                                    value={selectableTrabalhos.find(t => t.id === slot.trabalhoId) || extraData?.trabalho || null}
                                                    onChange={(_, newValue) => selectExtraTrabalho(slot.slotId, newValue?.id || null)}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Selecionar trabalho" variant="outlined" size="small" />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    noOptionsText="Nenhum trabalho em monitoramento disponível"
                                                />
                                                <IconButton
                                                    size="small"
                                                    color="error"
                                                    onClick={() => removeExtraTrabalho(slot.slotId)}
                                                    sx={{ flexShrink: 0 }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                            {extraData && (
                                                <>
                                                    <LinearProgress
                                                        variant="determinate"
                                                        value={extraData.progress}
                                                        sx={{ mt: 0.5, height: 4, borderRadius: 2 }}
                                                    />
                                                    {extraData.loading && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            Carregando traçado... {extraData.progress}%
                                                        </Typography>
                                                    )}
                                                </>
                                            )}
                                        </Box>
                                    );
                                })}

                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    onClick={addExtraSlot}
                                    sx={{ mt: 0.5, width: '100%' }}
                                >
                                    Adicionar trabalho
                                </Button>
                            </BasicCard>

                        {renderTrabalhoStatus()}
                        <BasicCard style={{ marginBottom: values.margin[1], }} title={strings.getString('screen_monitorItem_general_data')} color={'primary'} >
                            <div style={monitorInfoCardStyle}>
                                <div style={monitorFieldsRowStyle}>
                                    <TextField label={strings.getString('screen_monitorItem_date_initial')} style={monitorFieldStyle} value={trabalho.data_inicio ? DateFormat(new Date(trabalho.data_inicio)) : ' - - '} InputProps={{ startAdornment: (<InputAdornment position="start"><DateRangeIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_speed_actual')} style={monitorFieldStyle} error={validaVelocidade} value={velocidadeMedia} InputProps={{ startAdornment: (<InputAdornment position="start"><SpeedIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_hours_work')} style={monitorFieldStyle} value={horasTrabalhadas} InputProps={{ startAdornment: (<InputAdornment position="start"><AccessTimeIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_distance_traveled')} style={monitorFieldStyle} value={distanciaPercorrida} InputProps={{ startAdornment: (<InputAdornment position="start"><TrendingUpIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('info_operator')} style={monitorFieldStyle} value={operador} InputProps={{ startAdornment: (<InputAdornment position="start"><PersonIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('unity_talhao')} style={monitorFieldStyle} value={talhao} InputProps={{ startAdornment: (<InputAdornment position="start"><MapIcon /></InputAdornment>), }} variant="standard" />
                                </div>
                                <Typography style={monitorSectionTitleStyle} color='primary'>{strings.getString('screen_monitorItem_general_settings')}</Typography>
                                <div style={monitorFieldsRowStyle}>
                                    <TextField label={strings.getString('screen_monitorItem_number_lines')} style={monitorFieldStyle} value={linhasPlantadeiraMedia} InputProps={{ startAdornment: (<InputAdornment position="start"><ViewHeadlineIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_antenna_height')} style={monitorFieldStyle} value={antemaAlturaM} InputProps={{ startAdornment: (<InputAdornment position="start"><VerticalAlignTopIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_line_spacing')} style={monitorFieldStyle} value={especamentoLinhas} InputProps={{ startAdornment: (<InputAdornment position="start"><ExpandIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('warn_speed_max_permited')} style={monitorFieldStyle} value={velocidadeMaxPermitida} InputProps={{ startAdornment: (<InputAdornment position="start"><ReportIcon /></InputAdornment>), }} variant="standard" />
                                </div>
                            </div>
                        </BasicCard>
                        {trabalho.plantio && trabalho.plantio.plantio_ponto &&
                        <BasicCard style={{ marginBottom: values.margin[1], }}>
                            <div style={monitorInfoCardStyle}>
                                <Typography style={{ ...monitorSectionTitleStyle, marginTop: 0 }} color='primary'>{strings.getString('screen_monitorItem_planting_data')}</Typography>
                                <div style={monitorFieldsRowStyle}>
                                    <TextField label={strings.getString('unity_area')} style={monitorFieldStyle} value={areaPlantada} InputProps={{ startAdornment: (<InputAdornment position="start"><RoomIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_seeds_meter')} style={monitorFieldStyle} error={erroSementeMetro} value={sementesMetro} InputProps={{ startAdornment: (<InputAdornment position="start"><ScatterPlotIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_seeds_hectare')} style={monitorFieldStyle} value={sementesHectare} InputProps={{ startAdornment: (<InputAdornment position="start"><ScatterPlotIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_total_population')} style={monitorFieldStyle} value={populacaoTotal} InputProps={{ startAdornment: (<InputAdornment position="start"><TextureIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_average_population_lines')} style={monitorFieldStyle} value={populacaoMedia} InputProps={{ startAdornment: (<InputAdornment position="start"><DragIndicatorIcon /></InputAdornment>), }} variant="standard" />
                                </div>
                                <Typography style={monitorSectionTitleStyle} color='primary'>{strings.getString('screen_monitorItem_planting_settings')}</Typography>
                                <div style={monitorFieldsRowStyle}>
                                    <TextField label={strings.getString('screen_monitorItem_maximum_seed_rate')} style={monitorFieldStyle} value={taxaSementesMetroMax} InputProps={{ startAdornment: (<InputAdornment position="start"><ArrowUpwardIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_seed_target_rate')} style={monitorFieldStyle} value={taxaSementesMetro} InputProps={{ startAdornment: (<InputAdornment position="start"><DoneIcon /></InputAdornment>), }} variant="standard" />
                                    <TextField label={strings.getString('screen_monitorItem_minimum_seed_rate')} style={monitorFieldStyle} value={taxaSementesMetroMin} InputProps={{ startAdornment: (<InputAdornment position="start"><ArrowDownwardIcon /></InputAdornment>), }} variant="standard" />
                                </div>
                            </div>
                        </BasicCard>}
                        {trabalho.pulv && trabalho.pulv.pulv_ponto &&
                            <BasicCard >
                                <div style={monitorInfoCardStyle}>
                                    <Typography style={{ ...monitorSectionTitleStyle, marginTop: 0 }} color='primary'>{strings.getString('screen_monitorItem_spray_data')}</Typography>
                                    <div style={monitorFieldsRowStyle}>
                                        <TextField label={strings.getString('unity_area_pulverized')} style={monitorFieldStyle} value={areaPulverizada} InputProps={{ startAdornment: (<InputAdornment position="start"><RoomIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('screen_monitorItem_current_pressure')} style={monitorFieldStyle} value={pressaoAtual} error={erroPressaoAtual} InputProps={{ startAdornment: (<InputAdornment position="start"><TimelineIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('unity_target_flow')} style={monitorFieldStyle} value={vazaoAlvo} InputProps={{ startAdornment: (<InputAdornment position="start"><BrokenImageIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('screen_monitorItem_current_flow')} style={monitorFieldStyle} value={vazaoAtual} InputProps={{ startAdornment: (<InputAdornment position="start"><InvertColorsIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('screen_monitorItem_current_flow_min')} style={monitorFieldStyle} value={vazaoAtualMin} InputProps={{ startAdornment: (<InputAdornment position="start"><InvertColorsIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('unity_liters_consumed')} style={monitorFieldStyle} value={litrosConsumidos} InputProps={{ startAdornment: (<InputAdornment position="start"><LocalDrinkIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('screen_monitorItem_current_temperature')} style={monitorFieldStyle} value={temperaturaAtual} error={erroTemperaturaAtual} InputProps={{ startAdornment: (<InputAdornment position="start"><ThermostatIcon /></InputAdornment>), }} variant="standard" />
                                    </div>
                                    <Typography style={monitorSectionTitleStyle} color='primary'>{strings.getString('screen_monitorItem_spray_settings')}</Typography>
                                    <div style={monitorFieldsRowStyle}>
                                        <TextField label={strings.getString('screen_monitorItem_pressure_max')} style={monitorFieldStyle} value={pressaoMaxPsi} InputProps={{ startAdornment: (<InputAdornment position="start"><ArrowUpwardIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('screen_monitorItem_pressure_min')} style={monitorFieldStyle} value={pressaoMinPsi} InputProps={{ startAdornment: (<InputAdornment position="start"><ArrowDownwardIcon /></InputAdornment>), }} variant="standard" />
                                        <TextField label={strings.getString('screen_monitorItem_temperature_max')} style={monitorFieldStyle} value={configTemperaturaMax} InputProps={{ startAdornment: (<InputAdornment position="start"><WarningAmberIcon /></InputAdornment>), }} variant="standard" />
                                    </div>
                                </div>
                            </BasicCard>
                        }

                    </RowContainerItem>
                        <RowContainerItem>
                            <Stack sx={{ width: '100%', maxWidth: '100%', minWidth: 0, height: 'auto' }} spacing={3}>
                            <Typography variant="h6" color="primary" sx={{ alignSelf: 'flex-start' }}>
                                Deslocamento do trator
                            </Typography>
                            {mergedLinhas.linhas.length === 0 && (
                                <Typography variant="body2" color="text.secondary" sx={{ alignSelf: 'flex-start' }}>
                                    {mainVisible && linhas.length === 0
                                        ? 'Carregando pontos do mapa...'
                                        : !mainVisible && extraTrabalhos.length === 0
                                            ? 'Nenhum trabalho visível no mapa'
                                            : ''}
                                </Typography>
                            )}
                            <MapPanel
                                markers={mergedLinhas.markers}
                                zoomMap={zoomMap}
                                centerMap={mergedLinhas.center || centerMap}
                                linhas={mergedLinhas.linhas}
                                height={600}
                                implementWidthMeters={resolveImplementWidthMeters(trabalho)}
                            />
                            {mergedLinhas.legend?.length > 0 && (
                                <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5, pt: 0.5 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        Cores dos traçados:
                                    </Typography>
                                    {mergedLinhas.legend.map((itemLegend) => (
                                        <Box key={itemLegend.id} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                            <Box sx={{ width: 22, height: 10, borderRadius: 0.5, backgroundColor: itemLegend.color, flexShrink: 0 }} />
                                            <Typography variant="body2">{itemLegend.label}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            )}

                                {trabalho.pulv && trabalho.pulv.pulv_ponto &&
                                    <BasicCard title={`${strings.getString('screen_monitorItem_section_indicator')} - ( + ${trabalho.pulv.pulv_ponto.sessoes.length})`}>
                                        <WorksPulvSectionDisplay items={trabalho.pulv.pulv_ponto.sessoes} />
                                    </BasicCard>

                                }
                                {trabalho.plantio && trabalho.plantio.plantio_ponto &&
                                    <BasicCard style={{ flex:1, textAlign: 'center', color:"#F8C102", fontWeight: 'bold'}} title={trabalho.talhao} >
                                        <MonitorChartLimits linhas={trabalho.plantio.plantio_ponto.linhas} item={trabalho.plantio} />
                                    </BasicCard>        
                                }
                            </Stack>
                        </RowContainerItem>
                    </RowContainer>
                }
                {!trabalho && !loading &&
                    <ErrorCard
                        page='monitor'
                        title='Impossível encontrar o registro'
                        message='Não foi possível monitorar o trabalho, se o erro persistir entre em contato com o nosso suporte'
                    />
                }
            </div>
        </>
    );
}

export default MonitoringItem;
